import React, { useRef } from 'react';
import { overlayHoverGraceTime, MegaMenuCSSCustomProperties, } from '@polestar/component-warehouse-react/components/mega-menu/internal/MegaMenu.config';
import { useMegaMenu } from '@polestar/component-warehouse-react/components/mega-menu/internal/MegaMenuContext';
import Backdrop from '@polestar/component-warehouse-react/components/backdrop/Backdrop';
import { useInteractionMode } from '@polestar/component-warehouse-react/contexts/interactionMode';
import LayoutIndexes from '@polestar/component-warehouse-react/tokens/layout-indexes/LayoutIndexes';
import useMediaQuery from '@polestar/component-warehouse-react/hooks/useMediaQuery';
import DeviceTypes from '@polestar/component-warehouse-react/tokens/device-types/DeviceTypes';
export const MegaMenuBackdrop = (props) => {
    const { setMenuActive, setFlyoutActive, menuActive, flyoutActive, setActiveFlyoutIndex } = useMegaMenu();
    const timerRef = useRef(null);
    const { name } = useMediaQuery();
    const closeMenu = () => {
        setMenuActive(false);
        setFlyoutActive(false);
        setActiveFlyoutIndex(null);
    };
    const { isKeyboardControlled } = useInteractionMode();
    const onMouseEnter = () => {
        if (!flyoutActive || isKeyboardControlled)
            return;
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(closeMenu, overlayHoverGraceTime);
    };
    const onMouseLeave = () => {
        if (!flyoutActive || !timerRef.current)
            return;
        clearTimeout(timerRef.current);
        timerRef.current = null;
    };
    // on desktop the flyout can be often triggered and therefore the id needs to be unique to be cleaned up by Framer Motion. On mobile / tablet it is a kind of Drawer where you will see some glitching and while the Backdrop stays with the flyout it is best to skip the flyoutActive in the key
    const uniqueId = name === DeviceTypes.tablet || name === DeviceTypes.mobile
        ? `mega-menu-backdrop${menuActive}`
        : `mega-menu-backdrop${menuActive}-${flyoutActive}`;
    return (React.createElement(Backdrop, { key: uniqueId, visible: menuActive || flyoutActive, onClose: closeMenu, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, withoutModal: true, zIndexBaseValue: LayoutIndexes.content, inset: { mobile: '0', desktop: `var(${MegaMenuCSSCustomProperties.blockSize}, 0) 0 0` }, ...props }));
};
